import { useField } from "formik";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import { CkEditorCustom, SimpleLangCheck } from "src/app/components";
import { SimpleFormControl } from "src/app/components/form/SimpleFormControl";
import { SimpleFormSelect, SimpleFormSelectOption } from "src/app/components/form/SimpleFormSelect";
import { LangType } from "src/app/types/LangType";

export interface IUpsertTemplateForm {
    tagsOptions?: {
        options: SimpleFormSelectOption[];
        loading: boolean;
        refresh(lang: LangType): void;
    };
}
const UpsertTemplateForm = (props: IUpsertTemplateForm) => {
    const { tagsOptions = { options: [], loading: false, refresh: () => {} } } = props;

    const { formatMessage } = useIntl();

    const [textProps, , textHelper] = useField("text");
    const [langProps] = useField("lang");

    useEffect(() => {
        tagsOptions.refresh(LangType[langProps.value as keyof typeof LangType]);
    }, [langProps.value]);

    return (
        <div className="upsertTemplateWrapper">
            <div className="info">
                <SimpleFormControl
                    name="title"
                    label={formatMessage({ id: "common.field.title" })}
                />
                <SimpleFormSelect
                    name="tag"
                    label={formatMessage({ id: "common.field.tag" })}
                    values={tagsOptions?.options}
                    isLoading={tagsOptions.loading}
                />
                <SimpleLangCheck />
            </div>

            <CkEditorCustom
                config={{
                    toolbar: {
                        items: [
                            "heading",
                            "|",
                            "bold",
                            "italic",
                            "underline",
                            "link",
                            "bulletedList",
                            "numberedList",
                            "|",
                            "outdent",
                            "indent",
                            "|",
                            "blockQuote",
                            "|",
                            "undo",
                            "redo",
                        ],
                    },
                }}
                data={textProps.value}
                onReady={(editor) => {
                    const data = editor.getData();
                    textHelper.setValue(data);
                }}
                onChange={(event, editor) => {
                    const data = editor.getData();
                    textHelper.setValue(data);
                }}
            />
        </div>
    );
};
export default UpsertTemplateForm;
